module.exports = __webpack_public_path__ + "static/img/blob.9ad10d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/blob.png
// module id = te0U
// module chunks = 0